import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const store = new Vuex.Store({
    // 定义状态 
    state: {
        wxId: localStorage["wxId"] ? localStorage["wxId"] : null,
        token: localStorage["token"] ? localStorage["token"] : null,
        //用户信息(包括微信ID)
        userInfo: localStorage["userInfo"] ? JSON.parse(localStorage["userInfo"]) : [],
        //学习记录
        historyList: localStorage["historyList"] ? JSON.parse(localStorage["historyList"]) : [],
    },
    getters: {

    },
    mutations: {
        updateWxId(state, wxIdStr) {
            state.wxId = wxIdStr;
            localStorage.setItem("wxId", state.wxId);
        },
        updateToken(state, tokenStr) {
            state.token = tokenStr;
            localStorage.setItem("token", state.token);
        },
        
        setUserInfo(state, userInfoStr) {
            state.userInfo.push(userInfoStr);
            localStorage.setItem("userInfo", JSON.stringify(state.userInfo));
        },
        //添加记录
        addHistory: (state, data) => {
            state.historyList.push(data);
            localStorage.setItem("historyList", JSON.stringify(state.historyList));
        },
    },
});


export default store


// WEBPACK FOOTER //
// ./src/store/index.js